<script lang="ts" setup>
import { ApiFaq } from '~~/server/api/faq'

const route = useRoute()
const { data: page, redirect } = await useFetchWithRedirect<ApiFaq>('/api/faq', { route })

if(redirect && !redirect?.error) {
    navigateTo(redirect.data.url, redirect.data.options)
}

useSchemaOrg([
    defineWebPage({
        name: page.value?.data.title,
    }),
])

// Page meta
usePageMeta({
    meta: page.value?.data.meta,
    title: page.value?.data.title,
})
</script>
<template>
  <article v-if="page">
    <PagesFaqPageHeader
      :title="page.data.title"
      heading-type="h1"
      class="mb-12 mb-md-15"
    />

    <ContainerFluid>
      <PagesFaqCategories :data="page.data.faq" />
      <div class="pt-12 pt-md-20 mt-4 mt-md-12 border-top">
        <LazyWidgetHelpdeskExt />
      </div>
    </ContainerFluid>
  </article>
</template>
